export default {
  '功能介绍：支持将烽火数据同步至飞书多维表格': '功能介绍：支持将烽火数据同步至飞书多维表格',
  '重置凭证后，原凭证将会失效，会导致数据表同步失败': '重置凭证后，原凭证将会失效，会导致数据表同步失败',
  '为保证数据安全，谨慎将凭证对外泄露': '为保证数据安全，谨慎将凭证对外泄露',
  插件名称: '插件名称',
  获取凭证: '获取凭证',
  重置凭证: '重置凭证',
  凭证已复制到粘贴板: '凭证已复制到粘贴板',
  '您确定要重置凭证吗，重置后，原凭证将会失效，会导致原多维表格数据同步失败': '您确定要重置凭证吗，重置后，原凭证将会失效，会导致原多维表格数据同步失败',
  多维表格数据同步插件: '多维表格数据同步插件'
};
